import { BaseColumnCheckbox, Colors } from '@gripp/shared-ui';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, Text } from 'react-native';

const BaseColumns: Record<string, { element: (info: any) => any }> = {
  name: {
    element: (info) => (
      <Text style={[styles.nameLabel, styles.cellText]}>{info.getValue()}</Text>
    ),
  },
};

export const useFileColumns = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper();

  const createCheckboxColumn = (
    accessor: string,
    cell: (info: any) => any,
    header: (info: any) => any
  ) =>
    columnHelper.accessor(accessor, {
      cell,
      header,
      meta: { style: styles.checkboxCell },
    });

  const createInfoColumn = (accessor: string, cell: (info: any) => any) =>
    columnHelper.accessor(accessor, {
      cell,
      header: () => t(`file.list.${accessor}`),
      meta: { style: styles.cell },
    });

  const cols: ColumnDef<unknown, never>[] = [];
  cols.push(
    createCheckboxColumn(
      'selected',
      BaseColumnCheckbox.checkbox,
      BaseColumnCheckbox.checkboxHeader
    )
  );
  Object.entries(BaseColumns).forEach(([k, v]) =>
    cols.push(createInfoColumn(k, v.element))
  );
  return cols;
};

const styles = StyleSheet.create({
  cell: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    paddingVertical: 4,
    ...Platform.select({
      web: { height: 50, paddingRight: 16 },
      default: { height: 68, paddingRight: 12 },
    }),
  },
  checkboxCell: {
    maxWidth: 50,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  nameLabel: { color: Colors.black },
  cellText: {
    fontSize: 16,
    lineHeight: 17,
    ...Platform.select({
      web: { fontWeight: '500', flexWrap: 'nowrap' },
      default: { fontWeight: '400', flexWrap: 'wrap' },
    }),
  },
});
